import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtTextFieldPWD from "../Components/CustomTool/CtTxtPWD";
import CtCmb from "../Components/CustomTool/CtCmb";
import CtTxtNum from "../Components/CustomTool/CtTxtNum";
import MaterialTable from "../Components/CustomTool/MaterialTable";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
// import DepartmentMaster from "./DepartmentMaster";
import { Stack } from "@mui/material";
// import PlantMaster from "./PlantMaster";
// import { fetchUser } from "../Components/API";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import { fetchPulleyPrice } from "./API";
import MobileTable from "./CustomTool/MobileTable";
import CtART from "./CustomTool/ResponsiveTable";
import axios from "axios";
import CtTxtAmt from "../Components/CustomTool/CtTxtAmt";
import CtCmbEditable from "./CustomTool/CtCmbEditable";

class PulleyPriceList extends Component {
  state = {
    Unit: [{ vac_type: "Type" }],
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
      },
      {
        accessorKey: "bint_pulleydia",
        header: "Pulley Dia",
      },
      {
        accessorKey: "bint_ropedia",
        header: "Rope Dia",
      },
      {
        accessorKey: "bint_noofgroove",
        header: "No Of Groove",
      },
      {
        accessorKey: "vac_pulleysize",
        header: "Pulley Size",
      },
      {
        accessorKey: "dec_price",
        header: "Price",
      },
    ],

    rows: [],
    formData: {
      bint_srno: 0,
      txtPulleyDia: "",
      txtRopeDia: "",
      txtNoOfGroove: "",
      txtPulleySize: "",
      txtPrice: "",
    },
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "Pulley Price List");
    this.props.verifyUserID(
      this.getInfo,
      this.props.setUserPrivileges,
      this.props.modules.pulleyprice
    );
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.savePulleyPrice,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtPulleyDia
        );
      }
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "bint_pulleydia",
      "bint_ropedia",
      "bint_noofgroove",
      "vac_pulleysize",
      "dec_price",
    ]);
    const bint_srno = row.bint_srno,
      txtPulleyDia = row.bint_pulleydia,
      txtRopeDia = row.bint_ropedia,
      txtNoOfGroove = row.bint_noofgroove,
      txtPulleySize = row.vac_pulleysize,
      txtPrice = row.dec_price;
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtPulleyDia,
        txtRopeDia,
        txtNoOfGroove,
        txtPulleySize,
        txtPrice,
      },
    });
    document.getElementById("txtPulleyDia").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "bint_pulleydia"]);
    this.DeleteData(row.bint_srno, row.bint_pulleydia);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListPulleyPrice",
    };
    fetchPulleyPrice(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.ListPulleyPrice,
          rowsCount = rows.length;
        this.setState({
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("txtPulleyDia").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          txtPulleyDia: "",
          txtRopeDia: "",
          txtNoOfGroove: "",
          txtPulleySize: "",
          txtPrice: "",
        },
      },
      () => {
        document.getElementById("txtPulleyDia").focus();
      }
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationPulleyPrice = () => {
    let result = false;
    if (this.state.formData.txtPulleyDia.length <= 0) {
      this.props.toastErrorMsg("Enter Pulley Dia", "txtPulleyDia");
    } else if (this.state.formData.txtRopeDia.length <= 0) {
      this.props.toastErrorMsg("Enter Rope Dia", "txtRopeDia");
    } else if (this.state.formData.txtNoOfGroove.length <= 0) {
      this.props.toastErrorMsg("Enter No Of Groove", "txtNoOfGroove");
    } else if (this.state.formData.txtPulleySize.length <= 0) {
      this.props.toastErrorMsg("Enter Pulley Size", "txtPulleySize");
    } else if (this.state.formData.txtPrice.length <= 0) {
      this.props.toastErrorMsg("Enter Price", "txtPrice");
    } else {
      result = true;
    }
    return result;
  };

  savePulleyPrice = () => {
    this.trimFormData(() => {
      if (this.validationPulleyPrice()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SavePulleyPrice",
          bint_srno: this.state.formData.bint_srno,
          bint_pulleydia: this.state.formData.txtPulleyDia,
          bint_ropedia: this.state.formData.txtRopeDia,
          bint_noofgroove: this.state.formData.txtNoOfGroove,
          vac_pulleysize: this.state.formData.txtPulleySize,
          dec_price: this.state.formData.txtPrice,
        };
        fetchPulleyPrice(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (
                res.data.ListPulleyPrice &&
                res.data.ListPulleyPrice.length > 0
              ) {
                rows = res.data.ListPulleyPrice;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  rows,
                  rowsCount,
                },
                () => {
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in Save Pulley Price .", error);
          });
      }
    });
  };

  DeleteData = (bint_srno, bint_pulleydia) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete Pulley Dia : ${bint_pulleydia} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeletePulleyPrice(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeletePulleyPrice = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeletePulleyPrice",
      bint_srno: bint_srno,
    };
    fetchPulleyPrice(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.ListPulleyPrice && res.data.ListPulleyPrice.length > 0) {
            rows = res.data.ListPulleyPrice;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            }
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Pulley Price. " + error
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.savePulleyPrice}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtPulleyDia
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtNum
              id="txtPulleyDia"
              label="Pulley Dia*"
              maxLength={10}
              width="220"
              value={this.state.formData.txtPulleyDia}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
            />
          </Grid>
          <Grid item>
            <CtTxtNum
              id="txtRopeDia"
              label="Rope Dia*"
              maxLength={10}
              width="220"
              value={this.state.formData.txtRopeDia}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
            />
          </Grid>
          <Grid item>
            <CtTxtNum
              id="txtNoOfGroove"
              label="No Of Groove*"
              maxLength={10}
              width="220"
              value={this.state.formData.txtNoOfGroove}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtPulleySize"
              label="Pulley Size*"
              maxLength={100}
              width="220"
              value={this.state.formData.txtPulleySize}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtPrice"
              label="Price*"
              maxLength={10}
              width="220"
              value={this.state.formData.txtPrice}
              onKeyDown={this.props.onKeyDown}
              handleOnChange={this.handleOnChange}
              RupeeSymbol={true}
              defaultAction={this.savePulleyPrice}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Pulley Price")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={80}
              density={"compact"}
              hideColIdList={["bint_srno"]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <PulleyPriceList {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
